import { useState, useCallback, useRef } from 'react';

const SHORTCUTS = {
  '/suicidalnohx': `Given this is the patient's first new patient appointment. I did make a safety plan with the patient and discussed that if at any time the patient is feeling any suicidal thoughts or self-harm to self or others to:

Call the three people they listed today in the office as their emergency contacts and support system of their safety net:
1. (Person 1)
2. (Person 2)
3. (Person 3)

● Call 988 or 911 if in immediate danger: If you or someone you know is in crisis and needs immediate help, call 988 or 911.
● Text 988 for Crisis Text Line Support: To start a text conversation with the Lifeline, send any message to 988.
● Provide the National Suicide Prevention Lifeline number: 1-800-273-TALK (8255)
● Offered crisis text line support: Text HOME to 741741 to connect with a trained crisis counselor
● Arrive at the nearest hospital if in immediate danger to yourself or others
The patient agrees to the above and states understanding.`,

  '/suicidalhx': `Given the patient's suicidal thoughts in the past and history. I did make a safety plan with the patient and discussed that if at any time the patient is feeling any suicidal thoughts or self-harm to self or others to:

Call the three people they listed today in the office as their emergency contacts and support system of their safety net:
1. (Person 1)
2. (Person 2)
3. (Person 3)

● Call 988 or 911 if in immediate danger: If you or someone you know is in crisis and needs immediate help, call 988 or 911.
● Text 988 for Crisis Text Line Support: To start a text conversation with the Lifeline, send any message to 988.
● Provide the National Suicide Prevention Lifeline number: 1-800-273-TALK (8255)
● Offered crisis text line support: Text HOME to 741741 to connect with a trained crisis counselor
● Arrive at the nearest hospital if in immediate danger to yourself or others
The patient agrees to the above and states understanding.`,

  '/medfemparents': `Discussed with the patient and her parents about medications along with lens therapy. Discuss with the patient and her parents to become aware of the top side effects of each medication. LENS could have the potential to help patients decrease certain medications. But to never decrease any medication without first discussing this with their child's prescribing physician. Discuss with the patient and her parents about any questions or concerns with medication along with lens therapy. All questions and concerns were answered before the start of LENS. The patient and her parents are both aware and stated understanding that any medication changes to dosages should be discussed and completed with the prescribing physician.`,

  '/medfemaleparent': `Discussed with the patient and her parent about medications along with lens therapy. Discuss with the patient and her parent to become aware of the top side effects of each medication. LENS could have the potential to help patients decrease certain medications. But to never decrease any medication without first discussing this with their child's prescribing physician. Discussed with the patient and her parent any questions or concerns with medication along with lens therapy. All questions and concerns were answered before the start of LENS. The patient and her parent are both aware and stated understanding that any medication changes to dosages should be discussed and completed with the prescribing physician.`,

  '/medmaleparent': `Discussed with the patient and his parent about medications along with lens therapy. Discuss with the patient and his parent to become aware of the top side effects of each medication. LENS could have the potential to help patients decrease certain medications. But to never decrease any medication without first discussing this with their child's prescribing physician. Discussed with the patient and his parent any questions or concerns with medication along with lens therapy. All questions and concerns were answered before the start of LENS. The patient and his parent are both aware and stated understanding that any medication changes to dosages should be discussed and completed with the prescribing physician.`,

  '/medmaleparents': `Discussed with the patient and his parents about medications along with lens therapy. Discuss with the patient and his parents to become aware of the top side effects of each medication. LENS could have the potential to help patients decrease certain medications. But to never decrease any medication without first discussing this with their child's prescribing physician. Discuss with the patient and his parents any questions or concerns with medication along with lens therapy. All questions and concerns were answered before the start of LENS. The patient and his parents are both aware and stated understanding that any medication changes to dosages should be discussed and completed with the prescribing physician.`,

  '/1femgrandparent': `The patient (Pt) presents for her 1st LENS therapy new patient appointment today with her grandparent (who has custody of the patient). All consents have been signed prior to the LENS therapy session. I discussed with Pt and Pt's grandparent what to expect during the appointment today and in future appointments. The Pt and the Pt's grandparent stated no further questions or concerns prior to the start of the LENS therapy session. I reviewed the session and brain map assessment with Pt and Pt's grandparent. At the end of appt, the Pt and Pt's grandparent stated no further questions or concerns.`,

  '/1malgrandparent': `The patient (Pt) presents for his 1st LENS therapy new patient appointment today with his grandparent (who has custody of the patient). All consents have been signed prior to the LENS therapy session. I discussed with Pt and Pt's grandparent what to expect during the appointment today and in future appointments. The Pt and the Pt's grandparent stated no further questions or concerns prior to the start of the LENS therapy session. I reviewed the session and brain map assessment with Pt and Pt's grandparent. At the end of appt, the Pt and Pt's grandparent stated no further questions or concerns.`,

  '/1malparents': `The patient (Pt) presents for his 1st LENS therapy new patient appointment today with his parents. All consents have been signed prior to the LENS therapy session. I discussed with Pt and the Pt's parents what to expect during the appointment today and in future appointments. The Pt and the Pt's parents stated no further questions or concerns prior to the start of the LENS therapy session. I reviewed the session and brain map assessment with Pt and Pt's parents. At the end of appt, the Pt and Pt's parents stated no further questions or concerns.`,

  '/1femparents': `The patient (Pt) presents for her 1st LENS therapy new patient appointment today with her parents. All consents have been signed prior to the LENS therapy session. I discussed with Pt and the Pt's parents what to expect during the appointment today and in future appointments. The Pt and the Pt's parents stated no further questions or concerns prior to the start of the LENS therapy session. I reviewed the session and brain map assessment with Pt and Pt's parents. At the end of appt, the Pt and Pt's parents stated no further questions or concerns.`,

  '/1femparent': `The patient (Pt) presents for her 1st LENS therapy new patient appointment today with her parent. All consents have been signed prior to the LENS therapy session. I discussed with Pt and the Pt's parent what to expect during the appointment today and in future appointments. The Pt and the Pt's parent stated no further questions or concerns prior to the start of the LENS therapy session. I reviewed the session and brain map assessment with Pt and Pt's parent. At the end of appt, the Pt and Pt's parent stated no further questions or concerns.`,

  '/1malparent': `The patient (Pt) presents for his 1st LENS therapy new patient appointment today with his parent. All consents have been signed prior to the LENS therapy session. I discussed with Pt and the Pt's parent what to expect during the appointment today and in future appointments. The Pt and the Pt's parent stated no further questions or concerns prior to the start of the LENS therapy session. I reviewed the session and brain map assessment with Pt and Pt's parent. At the end of appt, the Pt and Pt's parent stated no further questions or concerns.`,

  '/efather': `Email received from the patient's father as requested for updates on the patients since the last appointment (see below):
Sent:
Received:`,

  '/emother': `Email received from the patient's mother as requested for updates on the patients since the last appointment (see below):
Sent:
Received:`,

  '/2026##': `2026: ## total, (first year in LENS, first appointment ##)`,

  '/an': `(all NOM)`,

  '/n': `(NOM)`,

  '/1st': `The patient (Pt) presents for the 1st LENS therapy session appointment today. All consents have been signed prior to the LENS therapy session. I discussed with Pt what to expect during the appointment today and in future appointments. Pt stated no further questions or concerns prior to the LENS therapy session. I reviewed the session and brain map assessment with the Pt. At the end of the appointment, the Pt stated no further questions or concerns.`,

  '/1femmother': `The patient (Pt) presents for the 1st LENS therapy session appointment today with her mother. All consents have been signed before the LENS therapy session. Discussed with Pt and Pt's mother what to expect during the appointment today and in future appointments. Pt and Pt's mother stated no further questions or concerns prior to the LENS therapy session. Reviewed the session with Pt and Pt's parent. At the end of appt, Pt and Pt's mother stated no further questions or concerns.`,

  '/2025total': `2025 Total Appointments`,

  '/firstyear': `(first year in LENS, first appointment ##)`,

  '/ah': `(all hypo)`,

  '/hy': `(hypo)`,

  '/bothhy': `(both hypo)`,

  '/2ndMap': `Compiled 2nd Map:

SS:
CBU:
S:
More Flex.`,

  '/good': `good and relaxed`,

  '/mfeelings': `The patient expressed his thoughts, feelings, and concerns throughout the appointment.`,

  '/ffeelings': `The patient expressed her thoughts, feelings, and concerns throughout the appointment.`,

  '/cbt': `Changed back to`,

  '/sw': `Stayed with`,

  '/arr26': `The patient (Pt) arrived for their # LENS therapy appointment in 2026. It has been # week(s) since the Pt's last appt.`,

  '/meds': `When overviewing the assessments after the patient's LENS appt, the patient reports they are still taking ####. Pt does report some moments of irritability (or insert other symptoms) lately. We discussed if the pt would be ready or open to weaning down on some of the medication if it was the right time. Pt reports they will think about it and reach out to her doctor about weaning down. I did advise the patient to reach out to her prescribing doctor for any medication changes.`,

  '/W': `The patient has been progressing so well. Will will transition to every two-week follow-ups. The patient agrees.`,

  '/1%': `Stayed with 1%
1% # alt
or
Switched back to 100%
100% # alt`,

  '/100%': `Stayed with 100%
100% # alt
or
Switched back to 1%
1% # alt`,

  '/ct': `Changed to`,

  '/Redlight': `Red Light Therapy (RLT) was completed on Pt's head and neck.
RLT was completed post LENS.
# mins`,

  '/1stBM': `1st Brain Map Completed.

#/21 sites are suppressed.

US:
VS:
HDF:
LDF:
S:

I will likely focus on the following brain sites below at the next appointment.`,

  '/WL': `I will likely focus on the brain sites listed below for the next appointment.`,

  '/BL': `Body LENS (BL) was completed on Pt's marked areas (black dots) #.
BL completed post LENS.
# mins`,

  '/LT': `LENS Therapy`,

  '/P': `patient`,

  '/PR': `Patient Reports`,

  '/PS': `patient States`,

  '/Will': `Will reassess brain sites prior to Pt's next scheduled appt.`,

  '/AL': `At the end of the LENS therapy session, the patient reports feeling`,

  '/total': `Total LENS Appts Per Year:

2023:
2022:
2021:`,
};

/**
 * useSlashCommands — React hook that adds slash-command autocomplete to
 * any text input/textarea in the Enrollment module.
 *
 * @param {Function} setValue  Called as setValue(fieldName, newValue) when a
 *                             shortcut is applied so the parent can update its
 *                             controlled state directly.
 *
 * @returns {{ getSlashProps, dropdownState, applyShortcut }}
 *   getSlashProps(fieldName, originalOnChange) — spread onto a MUI TextField
 *     or native <input> to wire up the slash behaviour.
 *   dropdownState — pass to <SlashCommandDropdown state={...} onSelect={...} />.
 *   applyShortcut(index) — select item at index (also called internally on
 *     keyboard Enter).
 */
export function useSlashCommands(setValue) {
  const [dropdownState, setDropdownState] = useState({
    visible: false,
    items: [],
    selectedIndex: 0,
    top: 0,
    left: 0,
  });


  const activeRef = useRef({ name: null, value: '', caretPos: 0 });
  const dropdownRef = useRef(dropdownState);
  dropdownRef.current = dropdownState;

  const hideDropdown = useCallback(() => {
    setDropdownState(prev =>
      prev.visible ? { ...prev, visible: false, selectedIndex: 0 } : prev
    );
  }, []);

  const applyShortcut = useCallback((index) => {
    const { name, value, caretPos } = activeRef.current;
    const { items } = dropdownRef.current;
    if (!items[index]) return;
    const [, replacement] = items[index];
    const textBeforeCaret = value.substring(0, caretPos);
    const lastSlashIndex = textBeforeCaret.lastIndexOf('/');
    if (lastSlashIndex !== -1) {
      const newVal =
        value.substring(0, lastSlashIndex) +
        replacement +
        value.substring(caretPos);
      setValue(name, newVal);
    }
    hideDropdown();
  }, [setValue, hideDropdown]);

 
  const getSlashProps = useCallback((fieldName, originalOnChange) => ({
    onChange: (e) => {
      if (originalOnChange) originalOnChange(e);

      const input = e.target;
      const val = input.value;
      const caretPos = input.selectionStart;
      activeRef.current = { name: fieldName, value: val, caretPos };

      const textBeforeCaret = val.substring(0, caretPos);
      const lastSlashIndex = textBeforeCaret.lastIndexOf('/');

      if (lastSlashIndex !== -1) {
        const afterSlash = textBeforeCaret.substring(lastSlashIndex);
        if (!afterSlash.includes(' ') && !afterSlash.includes('\n')) {
          const filtered = Object.entries(SHORTCUTS).filter(([key]) =>
            key.toLowerCase().includes(afterSlash.toLowerCase())
          );
          if (filtered.length > 0) {
            const rect = input.getBoundingClientRect();
            setDropdownState({
              visible: true,
              items: filtered,
              selectedIndex: 0,
              top: rect.bottom + window.scrollY + 4,
              left: rect.left + window.scrollX,
            });
            return;
          }
        }
      }
      setDropdownState(prev =>
        prev.visible ? { ...prev, visible: false, selectedIndex: 0 } : prev
      );
    },

    onKeyDown: (e) => {
      if (!dropdownRef.current.visible) return;
      const itemCount = dropdownRef.current.items.length;
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        setDropdownState(prev => ({
          ...prev,
          selectedIndex: (prev.selectedIndex + 1) % itemCount,
        }));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        setDropdownState(prev => ({
          ...prev,
          selectedIndex: (prev.selectedIndex - 1 + itemCount) % itemCount,
        }));
      } else if (e.key === 'Enter') {
        e.preventDefault();
        applyShortcut(dropdownRef.current.selectedIndex);
      } else if (e.key === 'Escape') {
        hideDropdown();
      }
    },

    onBlur: () => setTimeout(hideDropdown, 200),
  }), [hideDropdown, applyShortcut]);

  return { getSlashProps, dropdownState, applyShortcut };
}
